var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center border h-full w-full"},[_vm._v(" Version:   "),_c('code',{staticClass:"text-error"},[_vm._v(_vm._s(_vm.VERSION))])])
}
var staticRenderFns = []

export { render, staticRenderFns }